<template>
  <el-card class="my-box-card">
    <el-table
      :data="tableData"
      v-loading="loadingTable"
      style="width: 100%">
      <el-table-column align="left" prop="productName" show-overflow-tooltip label="产品/方法" min-width="200"/>
      <el-table-column align="left" prop="cnName" show-overflow-tooltip label="检验标准" min-width="150"/>
      <el-table-column
        prop="auditState"
        label="状态"
        align="center"
        width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.auditState | formatStatusType">{{scope.row.auditState | formatStatus}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="auditDate"
        width="120"
        label="创建日期">
        <template slot-scope="scope">
          {{scope.row.auditDate|dateToStr}}
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="操作"
        width="120">
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="view(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-bind:child-msg="pageParam" @callFather="callFather"></pagination>
    <el-dialog
      title="查看企标"
      :visible.sync="viewDialogVisible"
      width="70%"
      center>
      <el-form label-width="120px" :model="baseStandard" size="small" >
        <el-form-item label="检验产品/方法：">
          {{baseStandard.productName}}
        </el-form-item>
        <el-form-item label="检验标准：">
          {{baseStandard.standardName}}
        </el-form-item>
        <el-form-item label="检验项目：">
          <el-table
            :data="baseStandard.items"
            border
            style="width: 100%">
            <el-table-column
              prop="sno"
              label="编号"
              width="120">
            </el-table-column>
            <el-table-column
              prop="cnName"
              label="项目名称">
            </el-table-column>
            <el-table-column
              prop="cnRequire"
              label="技术要求"
              width="180">
            </el-table-column>
            <el-table-column
              prop="price"
              label="价格（元）"
              width="120">
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import { entList, getEnt } from '@/api/test/baseStandard'

export default {
  name: 'myEnterpriseStandard',
  data () {
    return {
      tableData: [],
      viewDialogVisible: false,
      loadingTable: false,
      baseStandard: {
        items: [],
        standardName: '',
        productName: ''
      },
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  mounted: function () {
    this.initData()
  },
  methods: {
    initData: function () {
      let param = {}
      param.page = {
        pageNum: this.pageParam.currentPage,
        pageSize: this.pageParam.pageSize,
        orderBy: 'createTime'
      }
      this.loadingTable = true
      entList(param).then(res => {
        var result = res.data
        this.loadingTable = false
        if (result.rtnCode === '0') {
          this.tableData = result.bizData
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.loadingTable = false
        this.$message.error('列表加载失败')
      })
    },
    view (row) {
      let param = {}
      param.id = row.id
      getEnt(param).then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          this.baseStandard = result.bizData
          this.viewDialogVisible = true
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('获取失败')
      })
    },
    callFather (parm) {
      this.pageParam.currentPage = parm.currentPage
      this.pageParam.pageSize = parm.pageSize
      this.mockData()
    }
  },
  filters: {
    // 00 未付款 01 已付款待审核 02 付款完成 03 待发样品 04 平台待收样品 05 已收样待检测 06 检测中 07 已检测 08 待发送报告 09 反馈中 10 完成
    formatStatus: function (val) {
      let statusArr = {
        '0': '审核通过',
        '1': '待审核',
        '2': '审核驳回',
        '3': '冻结'
      }
      return statusArr[val]
    },
    formatStatusType: function (val) {
      if (val === '0') {
        return 'success'
      } else if (val === '2') {
        return 'warning'
      } else {
        return 'danger'
      }
    }
  }
}
</script>

<style scoped>

</style>
